import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { LABEL } from "./kwShared";

export function AddKeywordsDialog({ wid, brand, remaining, onClose, onSaved }) {
  const [text, setText] = useState("");
  const [tags, setTags] = useState("");
  const [target, setTarget] = useState("");
  const [saving, setSaving] = useState(false);
  const lines = [...new Set(text.split("\n").map((l) => l.trim().toLowerCase()).filter(Boolean))];
  const over = lines.length > remaining;
  const save = async () => {
    if (!lines.length) { toast.error("Add at least one keyword"); return; }
    setSaving(true);
    try {
      const { data } = await api.post(`/console/keywords/${wid}/keywords`, { keywords: lines, tags: tags.split(",").map((t) => t.trim()).filter(Boolean), target_url: target }, { params: brand ? { brand } : {} });
      toast.success(`${data.added} keyword${data.added !== 1 ? "s" : ""} added${data.skipped ? ` · ${data.skipped} already tracked` : ""}`);
      onSaved();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-lg" data-testid="kw-add-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Add keywords</DialogTitle>
          <DialogDescription>One keyword per line. They're checked at the next daily run, or straight away with Check now.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <div className="flex items-center justify-between mb-1"><label className={LABEL}>Keywords</label><span data-testid="kw-add-count" className={`font-mono-data text-[11px] ${over ? "text-rose-600" : "text-[#9FA1A4]"}`}>{lines.length} / {remaining} slots left</span></div>
            <Textarea data-testid="kw-add-text" value={text} onChange={(e) => setText(e.target.value)} placeholder={"plumber brisbane\nemergency plumber\nblocked drain repair"} className="bg-[#F6F6FD] border-[#EEEFEF] min-h-[160px] font-mono-data text-sm" />
          </div>
          <div><label className={`${LABEL} mb-1 block`}>Tags (comma separated, optional)</label><Input data-testid="kw-add-tags" value={tags} onChange={(e) => setTags(e.target.value)} placeholder="services, brisbane" className="bg-[#F6F6FD] border-[#EEEFEF]" /></div>
          <div><label className={`${LABEL} mb-1 block`}>Target page (optional)</label><Input data-testid="kw-add-target" value={target} onChange={(e) => setTarget(e.target.value)} placeholder="https://client.com.au/services/plumbing" className="bg-[#F6F6FD] border-[#EEEFEF]" /></div>
        </div>
        <DialogFooter>
          <Button data-testid="kw-add-save" onClick={save} disabled={saving || over || !lines.length} className="bg-[#06060C] text-white hover:bg-[#1c1c24] rounded-full">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : `Add ${lines.length || ""} keyword${lines.length === 1 ? "" : "s"}`}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
